import { useNavigate, useSearchParams } from "react-router-dom";
import TroubleshootingWizard from "@/components/TroubleshootingWizard";

export default function Troubleshooting() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const hasVideoError = searchParams.get("error") === "true";

    const handleReset = () => {
        navigate("/?retry=true");
    };

    const handleContactSupport = (_completedSteps: number[]) => {
        navigate("/contact-support");
    };

    return (
        <section className="max-w-5xl mx-auto space-y-6">
            <TroubleshootingWizard
                onReset={handleReset}
                onContactSupport={handleContactSupport}
                hasVideoError={hasVideoError}
            />
        </section>
    );
}
